import { QuoteCard as DSQuoteCard } from '@all-manager/design-system-v2';

import { type QuoteCardProps, useQuoteCard } from './useQuoteCard';

type Props = QuoteCardProps;

export default function QuoteCard(props: Props) {
  const hook = useQuoteCard(props);

  return (
    <DSQuoteCard
      quote={props.quote}
      providerHref={hook.providerHref}
      onProviderClick={hook.handleProviderClick}
      onEdit={hook.isAdmin ? hook.handleEdit : undefined}
      onDelete={hook.isAdmin ? hook.handleDelete : undefined}
      onAccept={hook.isAdmin ? hook.handleAccept : undefined}
      onRefuse={hook.isAdmin ? hook.handleRefuse : undefined}
      onResetToPending={hook.isAdmin ? hook.handleResetToPending : undefined}
      onAttachSignedDocument={hook.isAdmin && props.onAttachSignedDocument ? hook.handleAttachBpa : undefined}
    />
  );
}

export type { QuoteCardProps };
